import { Filter } from './filter'

export interface FilterResponse {
    facilities: Filter[]
}

export const isFilterResponse = (obj: any): obj is FilterResponse => {
    return typeof obj === 'object' && Array.isArray(obj.facilities)
}
